<div>
    <img [src]="imageLocation + encode(image?.FileInfo.FileName)" alt="{{image?.Caption}}" class="maximizedImage"
        [focus]="maximizedImageFocuser" (keydown)="hideMaximizedImage()" (click)="hideMaximizedImage()" tabindex="1">
</div>
